<!--코드 신규 등록 팝업 -->
<template>
    <modal v-if="isModalShow">
        <template slot="header">
          <h4 class="modal-title">신규 등록</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="closed">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <template slot="body">
          <div class="md-layout">

            <md-card-content>
              <table class="flex-table">
                <tr>
                  <th>코드</th>
                  <th>코드명</th>
                  <th>코드상세</th>
                  <th>정렬순서</th>
                  <th>사용여부</th>
                </tr>
                <tr>
                  <td><input type="text" v-model="addData.codeCd" :disabled="isEdit"/></td>
                  <td><input type="text" v-model="addData.codeNm"   /></td>
                  <td><input type="text" v-model="addData.codeDesc" /></td>
                  <td><input type="text" v-model="addData.codeOrdr" /></td>
                  <td><input type="text" v-model="addData.useYn" /></td>
                </tr>
                <tr>
                  <th>참조1</th>
                  <th>참조2</th>
                  <th>참조3</th>
                  <th>참조4</th>
                  <th>참조5</th>
                </tr>
                <tr>
                  <td><input type="text" v-model="addData.etcMeta1" /></td>
                  <td><input type="text" v-model="addData.etcMeta2" /></td>
                  <td><input type="text" v-model="addData.etcMeta3" /></td>
                  <td v-if="this.grpRow.codeGrpId != 'WORK_CD'"><input type="text" v-model="addData.etcMeta4" /></td>
                  <td v-if="this.grpRow.codeGrpId != 'WORK_CD'"><input type="text" v-model="addData.etcMeta5" /></td>
                  <td v-if="this.grpRow.codeGrpId == 'WORK_CD'"><input type="text" v-model="addData.etcMeta4" disabled /></td>
                  <td v-if="this.grpRow.codeGrpId == 'WORK_CD'"><input type="text" v-model="addData.etcMeta5" disabled /></td>
                </tr>
              </table>
            </md-card-content>

          </div>

        </template>
        <template slot="footer">
          <md-button class="md-info md-sm" @click="add" v-auth-btn="[5,3]">
            <md-icon>check</md-icon>저장
          </md-button>
          <md-button class="md-default md-sm" @click="closed">닫기</md-button>
        </template>
      </modal>
</template>

<script>

import { Modal } from "@/components";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";

import Swal from "sweetalert2";

export default {
  name: "AddCodePopComp",
  props: {
    isEdit : {
      type: Boolean,
      default: false
    },
    isShow : {
      type: Boolean,
      default: false
    },
    addCodeType: {
      type: String,
      default: ''
    },
    addCodeGrpRow: {
      type: Object,
      default: null
    },
    addCodeLRow: {
      type: Object,
      default: null
    },
    addCodeMRow: {
      type: Object,
      default: null
    }
  },
  components: {
    Modal
  },

  created() {
    
  },

  computed: {
    isModalShow: function(){
      return this.isShow;
    },
    type: function() {
      return this.addCodeType;
    },
    grpRow: function() {
      return this.addCodeGrpRow;
    },
    lRow: function() {
      return this.addCodeLRow;
    },
    mRow: function() {
      return this.addCodeMRow;
    }
  },
  data() {
    return {
      addData: {
        codeGrpId: '',  // 코드그룹ID
        codeCd: '',
        codeNm: '',  // 분류코드명
        codeDesc: '',  // 분류코드설명
        etcMeta1: '', // 참조1
        etcMeta2: '', // 참조2
        etcMeta3: '', // 참조3
        etcMeta4: '', // 참조4
        etcMeta5: '', // 참조5
        codeOrdr: 99,  // 정렬순서
        useYn: '',
        // INSERT_DATE: '',  // 등록일
        // INSERT_USER_NO: '', // 등록자사원번호
        // UPDATE_DATE: '',  // 수정일
        // UPDATE_USER_NO: ''  // 등록자사원번호
      }
    };
  },

  methods: {
    clearData (){
      this.addData = {
        codeGrpId: '',  // 코드그룹ID
        codeCd: '',
        codeNm: '',  // 분류코드명
        codeDesc: '',  // 분류코드설명
        etcMeta1: '', // 참조1
        etcMeta2: '', // 참조2
        etcMeta3: '', // 참조3
        etcMeta4: '', // 참조4
        etcMeta5: '', // 참조5
        codeOrdr: 99,  // 정렬순서
        useYn: ''
      }
    },
    setData (data,type){
      this.addData = data;
      if(type == 'GRP'){
        this.addData.codeCd = data.codeGrpId;
      }
    },
    closed(){
        this.clearData();
        this.$emit('update:isShow', false);
    },

    add() {
      // console.log(this.type, this.grpRow, this.lRow, this.mRow);

      let options = [JSON.parse(JSON.stringify(this.addData))]; // 데이터를 배열로 보내야 해서 배열로 만듬
      let url = null;

      // 최상위 코드
      if (this.type === 'GRP') {
        url = URL_CONST.SAVE_CODE_GRP_LIST;

        options[0].codeGrpId = options[0].codeCd;
        delete(options[0].codeCd);
      }
      // 대분류 코드
      else if (this.type === 'L') {
        url = URL_CONST.SAVE_CODE_L_LIST;

        options[0].codeGrpId = this.grpRow.codeGrpId;
      }
      // 중분류 코드
      else if (this.type === 'M') {
        url = URL_CONST.SAVE_CODE_M_LIST;

        options[0].codeGrpId = this.grpRow.codeGrpId;
        options[0].lCodeCd = this.lRow.codeCd;
      }
      // 소분류 코드
      else if (this.type === 'S') {
        if(this.grpRow.codeGrpId == 'WORK_CD'){
          url = URL_CONST.SAVE_CPN_LIST;
        }else{
          url = URL_CONST.SAVE_CODE_S_LIST;
        }
        options[0].codeGrpId = this.grpRow.codeGrpId;
        options[0].lCodeCd = this.lRow.codeCd;
        options[0].mCodeCd = this.mRow.codeCd;
      }

      kuaaApi.sendServer(url, options, "post", response => {
        this.$emit('returnResult', 'success');
        this.closed();
      });
    }
  }
}
</script>

<style lang="css" scoped>

</style>